import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { Router } from '@angular/router';
import { inject, Injectable } from '@angular/core';

import { ISS_REDIRECT_URI } from '../auth.config';

import { AuthContext } from '@iss/libs/auth';

@Injectable()
export class KeycloakGuard extends KeycloakAuthGuard {
  private readonly redirectUri = inject(ISS_REDIRECT_URI);

  constructor(router: Router, protected readonly keycloak: KeycloakService) {
    super(router, keycloak);
  }

  public async isAccessAllowed(): Promise<boolean> {
    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri: this.redirectUri,
        loginHint: AuthContext.getEmail(),
      });
    }

    return true;
  }
}
